import axios from 'axios';

export const getconfigData = async (pubid) => {
    const config = {
        headers: {
"access-token": localStorage.getItem('access-token'),      
          pubid: pubid,
        },
      };
    try {
        const response = await axios.get(process.env.REACT_APP_API_SERVER_HOST + '/config/data',config);
        return response.data;
    } catch (error) {
        return { data: [] };
    }
}

export const checkTokenAccess = async () => {
  const pubid = localStorage.getItem("pub_id")
  const accessToken = localStorage.getItem('access-token')
  const roleId = localStorage.getItem('role_id')
  const config = {
    headers: {
"access-token": localStorage.getItem('access-token'),
      "pubid": pubid,
      "access-token": accessToken,
      "role_id": roleId
    },
  };
  try {
    const response = await axios.post(process.env.REACT_APP_API_SERVER_HOST + '/auth/verify', null, config);
    return response.data;
  } catch (error) {
    return { error };
  }
}

export const getOnboardingStatus = async () => {
  const pubid = localStorage.getItem("pub_id");
  const accessToken = localStorage.getItem('access-token');
  const roleId = localStorage.getItem('role_id');
  const config = {
    headers: {
      "access-token": accessToken,
      "pubid": pubid,
      "role_id": roleId
    },
  };
  try {
    const response = await axios.get(process.env.REACT_APP_API_SERVER_HOST + '/onboarding/status', config);
    return response.data;
  } catch (error) {
    return { error };
  }
}